import { SKTPassword, SKTTextField } from "../../components/SKTTextField";
import { passthru } from "../../utils/validators";
import { SKTButton } from "../../components/SKTButton";
import { useData } from "../../hooks/Data";
import {
  SKTPanelHeading,
  SKTPanel,
  SKTPanelBody,
  SKTPanelFooter,
} from "../../components/SKTPanel";
import { SKTAction } from "../../components/SKTAction";
import { SKTInfo } from "../../components/SKTInfo";
import { SKTForm } from "../../components/SKTForm";
import { SKTBaseComponent } from "../../components/SKTBaseComponent";

export const LoginForm = ({ login, status, goForgot, goRegister }) => {
  const data = useData({
    validators: {
      username: passthru,
      password: passthru,
    },
  });

  const doLogin = () => {
    login(data.get("username"), data.get("password"));
  };

  return (
    <SKTPanel>
      <SKTPanelBody>
        <SKTInfo>{status}</SKTInfo>
        <SKTTextField data={data} id="username" label="Sähköpostiosoite" />
        <SKTPassword data={data} id="password" label="Salasana" />
        <SKTAction
          actionLabel="Kirjaudu sisään"
          onClick={doLogin}
          active={true}
          type="btn-success"
        ></SKTAction>
        <br />
        <SKTAction
          actionLabel="Rekisteröidy"
          onClick={goRegister}
          active={true}
          type="btn-primary"
        >
          Ei käyttäjätunnusta? Luo tunnus palveluun nyt, se vie aikaa vain
          muutaman hetken!
        </SKTAction>
        <br />
        <SKTAction
          actionLabel="Vaihda salasana"
          onClick={goForgot}
          active={true}
          type="btn-primary"
        >
          Salasana hukassa? Tilaa sähköpostiisi ohjeet salasanan vaihtamiseksi.
        </SKTAction>
      </SKTPanelBody>
    </SKTPanel>
  );
};
